import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/forms";
const _c0 = ["filterInput"];
function DataTableInfoHeaderComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function DataTableInfoHeaderComponent_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.showDropDown = !ctx_r5.showDropDown); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Choose Columns");
    i0.ɵɵelement(3, "i", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-expanded", ctx_r0.showDropDown)("aria-controls", "column-picker-dropdown-" + ctx_r0.tableId);
} }
function DataTableInfoHeaderComponent_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DataTableInfoHeaderComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, DataTableInfoHeaderComponent_div_3_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.leftSideHeaderTemplate);
} }
function DataTableInfoHeaderComponent_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DataTableInfoHeaderComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, DataTableInfoHeaderComponent_div_5_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.rightSideHeaderTemplate);
} }
function DataTableInfoHeaderComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 13)(1, "label", 14);
    i0.ɵɵtext(2, "Filter Results (all column search)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 15, 16);
    i0.ɵɵlistener("ngModelChange", function DataTableInfoHeaderComponent_span_6_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.filter = $event); })("ngModelChange", function DataTableInfoHeaderComponent_span_6_Template_input_ngModelChange_3_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.fireFilterChange()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "filter-", ctx_r3.tableId, "");
    i0.ɵɵproperty("ngModel", ctx_r3.filter);
    i0.ɵɵattribute("placeholder", ctx_r3.showFilterPlaceholders ? "Filter Results" : null);
} }
function DataTableInfoHeaderComponent_div_7_label_5_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label")(1, "input", 21);
    i0.ɵɵlistener("ngModelChange", function DataTableInfoHeaderComponent_div_7_label_5_Template_input_ngModelChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r16); const column_r14 = restoredCtx.$implicit; return i0.ɵɵresetView(column_r14.displayed = $event); })("ngModelChange", function DataTableInfoHeaderComponent_div_7_label_5_Template_input_ngModelChange_1_listener() { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.fireColumnChange()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r14 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", column_r14.displayed);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r14.header, " ");
} }
const _c1 = function (a0) { return { display: a0 }; };
function DataTableInfoHeaderComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "fieldset")(2, "legend", 18);
    i0.ɵɵtext(3, "Columns to display");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 19);
    i0.ɵɵtemplate(5, DataTableInfoHeaderComponent_div_7_label_5_Template, 3, 2, "label", 20);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", "column-picker-dropdown-" + ctx_r4.tableId)("hidden", !ctx_r4.showDropDown)("ngStyle", i0.ɵɵpureFunction1(5, _c1, !ctx_r4.showDropDown ? "none" : "block"));
    i0.ɵɵattribute("aria-hidden", !ctx_r4.showDropDown);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r4.allColumns);
} }
export class DataTableInfoHeaderComponent {
    constructor() {
        this.filterChange = new EventEmitter();
        this.columnChange = new EventEmitter();
        this.showDropDown = false;
    }
    fireFilterChange() {
        this.filterChange.emit({
            columns: this.allColumns,
            filter: this.filter,
            localPagingSize: this.localPagingSize,
        });
    }
    fireColumnChange() {
        this.columnChange.emit(this.allColumns);
    }
}
DataTableInfoHeaderComponent.ɵfac = function DataTableInfoHeaderComponent_Factory(t) { return new (t || DataTableInfoHeaderComponent)(); };
DataTableInfoHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataTableInfoHeaderComponent, selectors: [["DataTable-table-info-header"]], viewQuery: function DataTableInfoHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterInput = _t.first);
    } }, inputs: { leftSideHeaderTemplate: "leftSideHeaderTemplate", rightSideHeaderTemplate: "rightSideHeaderTemplate", columns: "columns", allColumns: "allColumns", columnPicker: "columnPicker", serverSideData: "serverSideData", filterable: "filterable", columnFiltering: "columnFiltering", filter: "filter", showFilterPlaceholders: "showFilterPlaceholders", localPagingSize: "localPagingSize", notifierService: "notifierService", tableId: "tableId" }, outputs: { filterChange: "filterChange", columnChange: "columnChange" }, decls: 8, vars: 5, consts: [[1, "info-header"], [1, "controls", "header-buttons"], ["class", "toggle-dropdown", "type", "button", 3, "click", 4, "ngIf"], ["class", "left-side-template", 4, "ngIf"], [1, "flex-spacer"], ["class", "right-side-template", 4, "ngIf"], ["class", "filter-box", 4, "ngIf"], ["class", "dropdown", "role", "region", "tabindex", "-1", 3, "id", "hidden", "ngStyle", 4, "ngIf"], ["type", "button", 1, "toggle-dropdown", 3, "click"], [1, "fa", "fa-fw", "fa-angle-down"], [1, "left-side-template"], [4, "ngTemplateOutlet"], [1, "right-side-template"], [1, "filter-box"], ["for", "filter", 1, "screen-reader"], ["type", "text", "name", "filter", 3, "id", "ngModel", "ngModelChange"], ["filterInput", ""], ["role", "region", "tabindex", "-1", 1, "dropdown", 3, "id", "hidden", "ngStyle"], [1, "screen-reader"], [1, "column-wrapper"], [4, "ngFor", "ngForOf"], ["type", "checkbox", 3, "ngModel", "ngModelChange"]], template: function DataTableInfoHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, DataTableInfoHeaderComponent_button_2_Template, 4, 2, "button", 2);
        i0.ɵɵtemplate(3, DataTableInfoHeaderComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵelement(4, "div", 4);
        i0.ɵɵtemplate(5, DataTableInfoHeaderComponent_div_5_Template, 2, 1, "div", 5);
        i0.ɵɵtemplate(6, DataTableInfoHeaderComponent_span_6_Template, 5, 3, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, DataTableInfoHeaderComponent_div_7_Template, 6, 7, "div", 7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.columnPicker);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.leftSideHeaderTemplate);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.rightSideHeaderTemplate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.filterable && !ctx.columnFiltering && ctx.columns.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.columnPicker);
    } }, dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, i2.DefaultValueAccessor, i2.CheckboxControlValueAccessor, i2.NgControlStatus, i2.NgModel], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableInfoHeaderComponent, [{
        type: Component,
        args: [{ selector: 'DataTable-table-info-header', template: `
    <div class="info-header">
      <div class="controls header-buttons">
        <button
          *ngIf="columnPicker"
          class="toggle-dropdown"
          type="button"
          (click)="showDropDown = !showDropDown"
          [attr.aria-expanded]="showDropDown"
          [attr.aria-controls]="'column-picker-dropdown-' + tableId"
        >
          <span>Choose Columns<i class="fa fa-fw fa-angle-down"></i></span>
        </button>
        <div *ngIf="leftSideHeaderTemplate" class="left-side-template">
          <ng-container *ngTemplateOutlet="leftSideHeaderTemplate"></ng-container>
        </div>
        <div class="flex-spacer"></div>
        <div *ngIf="rightSideHeaderTemplate" class="right-side-template">
          <ng-container *ngTemplateOutlet="rightSideHeaderTemplate"></ng-container>
        </div>
        <span class="filter-box" *ngIf="filterable && !columnFiltering && columns.length > 0">
          <label for="filter" class="screen-reader">Filter Results (all column search)</label>
          <input
            #filterInput
            type="text"
            name="filter"
            id="filter-{{ tableId }}"
            [(ngModel)]="filter"
            (ngModelChange)="fireFilterChange()"
            [attr.placeholder]="showFilterPlaceholders ? 'Filter Results' : null"
          />
        </span>
      </div>
      <div
        *ngIf="columnPicker"
        [id]="'column-picker-dropdown-' + tableId"
        class="dropdown"
        [attr.aria-hidden]="!showDropDown"
        role="region"
        tabindex="-1"
        [hidden]="!showDropDown"
        [ngStyle]="{ display: !showDropDown ? 'none' : 'block' }"
      >
        <fieldset>
          <legend class="screen-reader">Columns to display</legend>
          <div class="column-wrapper">
            <label *ngFor="let column of allColumns">
              <input type="checkbox" [(ngModel)]="column.displayed" (ngModelChange)="fireColumnChange()" />
              {{ column.header }}
            </label>
          </div>
        </fieldset>
      </div>
    </div>
  `, styles: ["/*# sourceMappingURL=table.component.css.map */\n"] }]
    }], null, { leftSideHeaderTemplate: [{
            type: Input
        }], rightSideHeaderTemplate: [{
            type: Input
        }], filterInput: [{
            type: ViewChild,
            args: ['filterInput']
        }], columns: [{
            type: Input
        }], allColumns: [{
            type: Input
        }], columnPicker: [{
            type: Input
        }], serverSideData: [{
            type: Input
        }], filterable: [{
            type: Input
        }], columnFiltering: [{
            type: Input
        }], filter: [{
            type: Input
        }], showFilterPlaceholders: [{
            type: Input
        }], localPagingSize: [{
            type: Input
        }], notifierService: [{
            type: Input
        }], tableId: [{
            type: Input
        }], filterChange: [{
            type: Output
        }], columnChange: [{
            type: Output
        }] }); })();
